import { Component, OnInit } from '@angular/core'
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms'
import { ActivatedRoute, Router } from '@angular/router'
import { AuthService } from '../../../services/auth.service'
import { FlashMessageService } from '../../../services/flash-message.service'

@Component({
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  form: UntypedFormGroup = this.formBuilder.group({
    password: ['', Validators.required],
    token: ['', Validators.required]
  })

  constructor(
    private formBuilder: UntypedFormBuilder,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private flashMessageService: FlashMessageService,
    private router: Router
  ) {}

  ngOnInit() {
    this.form.controls.token.setValue(
      this.activatedRoute.snapshot.queryParams.token
    )
  }

  submit() {
    this.authService
      .resetPassword(this.form.value.password, this.form.value.token)
      .subscribe(
        () => {
          this.flashMessageService.success(
            `Psst! Your password has been reset. Now you can log in with your new password.`
          )

          return this.router.navigate(['/login'])
        },
        (err) => {
          this.flashMessageService.error(err.error.message)
          this.form.reset()
        }
      )
  }
}
